<template>
  <div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0">
            {{ $t('orders.self') }}
          </h5>
        </div>
        <div class="d-flex justify-content-center">
          <b-button
            v-if="user.permissions.includes('ADMIN_MANAGE_REPORTS')"
            class="m-2"
            variant="success"
            @click="viewDateOrder = !viewDateOrder"
          >
            {{ $t('review.date_order') }}
          </b-button>
          <b-button
            class="m-2"
            variant="primary"
            @click="resetFilters"
          >
            {{ $t('review.reset_filters') }}
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <div v-if="viewDateOrder === true">
          <div class="col-md-4 m-4">
            <a-range-picker
              v-model="searching_period"
              :show-time="false"
              @change="handleDateFilter"
            >
              <a-icon
                slot="suffixIcon"
                type="smile"
              />
            </a-range-picker>
            <b-button
              class="m-2"
              variant="primary"
              @click="getOrder"
            >
              {{ $t('review.date_order_btn') }}
            </b-button>
          </div>
        </div>
        <a-table
          class="product-table"
          :columns="columns"
          :data-source="data"
          :pagination="pagination"
          :row-key="'id'"
          :loading="loading"
          :scroll="{x: 1400}"
          @change="handleTableChange"
        >
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown"
          >
            <a-input
              v-ant-ref="c => searchInput = c"
              :placeholder="`${$t('common.search_by')} ${column.dataIndex}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
            />
            <a-button
              type="primary"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(selectedKeys, confirm)"
            >
              {{ $t('common.search') }}
            </a-button>
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
            >
              {{ $t('common.reset') }}
            </a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="id"
            slot-scope="text, record"
          >
            <router-link
              :to="`/orders/${text}`"
              :class="`btn btn-sm ${getIdColor(record)}`"
            >
              {{ record.long_id }}
            </router-link>
          </template>
          <template
            slot="date_created"
            slot-scope="text"
          >
            {{ text | dateFormatter('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template
            slot="company"
            slot-scope="text"
          >
            <router-link
              :to="'/admin/seller/stores/' + text.hash_id"
              class="mr-2"
            >
              <span>{{ $l(text.title) }}</span>
            </router-link>
          </template>
          <template
            slot="buyer"
            slot-scope="text"
          >
            <span v-if="text.name">
              {{ text.name }}
              <span v-if="text.phone"> ({{ text.phone | phoneFormatter }})</span>
              <span v-else-if="text.email"> ({{ text.email }})</span>
            </span>
          </template>
          <template
            slot="amount"
            slot-scope="text"
          >
            <span>{{ text | currency }}</span><small>UZS</small>
          </template>
          <template
            slot="items"
            slot-scope="text"
          >
            <span :title="stringifyItems(text)">
              {{ stringifyItems(text) | shrinkString(50) }}
            </span>
          </template>
          <template
            slot="tracking_number"
            slot-scope="text"
          >
            {{ text }}
          </template>
          <template
            slot="status"
            slot-scope="text"
          >
            <OrderStatusTag
              :status="text.code"
              :text="$l(text.title)"
            />
          </template>
          <template
            slot="action"
            slot-scope="record"
          >
            <router-link :to="`orders/${record.id}`">
              <b-button
                size="sm"
                variant="light"
                class="mr-2"
              >
                <i class="fe fe-edit mr-2" />
                {{ $t('common.view') }}
              </b-button>
            </router-link>
          </template>
          <template
            slot="payment"
            slot-scope="isPaid"
          >
            <a-tag
              v-if="isPaid"
              color="green"
            >
              {{ $t('orders.paid') }}
            </a-tag>
            <a-tag
              v-else
              color="orange"
            >
              {{ $t('orders.not_paid') }}
            </a-tag>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import orderService from '@/services/api/admin/stores/order-service'
import postBranchesService from '@/services/api/admin/stores/post-branches-service'
import excelReportService from '@/services/api/admin/reports/excel-report-services'
import OrderStatusTag from '@/components/order/OrderStatusTag'
import { mapGetters } from 'vuex'

export default {
  name: 'Orders',
  components: {
    OrderStatusTag,
  },
  data() {
    return {
      searching_period: [moment().startOf('month'), moment().endOf('month')],
      viewDateOrder: false,
      searchText: '',
      loading: false,
      pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
      },
      sorting: {
        col: 'date_created',
        order: 'desc',
      },
      sortingT: {
        col: '',
        order: '',
      },
      filter: {
        title: '',
      },
      filters: {},
      searchInput: null,
      data: [],
      branches: [],
      userType: '',
      userTypeRole: '',
    }
  },

  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
    columns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          sorting: true,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'id',
          },
        },
        {
          title: this.$t('common.date'),
          dataIndex: 'date_created',
          sorter: true,
          scopedSlots: { customRender: 'date_created' },
        },
        {
          title: this.$t('orders.payment'),
          dataIndex: 'is_paid',
          key: 'is_paid',
          scopedSlots: {
            customRender: 'payment',
          },
          filterMultiple: false,
          filters: [
            {
              text: this.$t('orders.paid'),
              value: 'true',
            },
            {
              text: this.$t('orders.not_paid'),
              value: 'false',
            },
          ],
        },
        {
          title: this.$t('seller.self'),
          dataIndex: 'company',
          key: 'company',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'company',
          },
        },
        {
          title: this.$t('seller.branch'),
          dataIndex: 'company.branch.title',
          key: 'branch_id',
          filters: this.branches,
        },
        {
          title: this.$t('orders.customer'),
          dataIndex: 'buyer',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'buyer',
          },
        },
        {
          title: this.$t('orders.amount'),
          dataIndex: 'amount',
          sorter: true,
          scopedSlots: { customRender: 'amount' },
        },
        {
          title: this.$t('product.self_multiple'),
          dataIndex: 'items',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'items',
          },
        },
        {
          title: this.$t('orders.tracking_number'),
          dataIndex: 'tracking_number',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'tracking_number',
          },
        },
        {
          title: this.$t('topBar.status'),
          dataIndex: 'status',
          key: 'status_id',
          filters: Object.entries(orderStatusMap).map(([key, value]) => ({
            text: this.$l(value),
            value: key,
          })),
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  mounted() {
    this.fetchFilterFromParams()
    this.queryOrders()
    this.fetchBranches()
  },
  methods: {
    getOrder() {
      this.filter.date_from = this.searching_period[0].format('YYYY-MM-DD')
      this.filter.date_to = this.searching_period[1].format('YYYY-MM-DD')
      const fileName = 'Orders ' + this.filter.date_from + ' - ' + this.filter.date_to + '.xlsx'
      excelReportService.getSalesOrderExcel(this.pagination, this.sortingT, this.filter, fileName)
    },
    handleDateFilter(dates, dateStrings) {
      console.log('invoked on change')
      this.searching_period = dates
      this.fetchData()
    },
    resetFilters() {
      this.filters = {}
      this.queryOrders()
      this.saveRouteParams()
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    handleTableChange(pagination, filter, sorter) {
      if (sorter.columnKey && sorter.order)
        this.sorting = {
          col: sorter.columnKey,
          order: sorter.order.replace('end', ''), // ascend -> asc | descend -> desc
        }
      this.filters = {}
      Object.keys(filter).forEach(key => {
        if (filter[key] && filter[key].length > 0)
          this.filters[key] = filter[key].join(',')
        else
          this.filters[key] = null
      })

      this.pagination.current = pagination.current

      this.saveRouteParams()
      this.queryOrders()
    },
    queryOrders() {
      this.loading = true
      const mappedFilter = this.mapApiQuery(this.filters, 'filter')

      const mappedSort = this.mapApiQuery(this.sorting, 'sort')

      orderService.getOrders(this.pagination, mappedSort, mappedFilter)
        .then((response) => {
          if (response && response.data && response.data.content) {
            this.data = response.data.content
            this.pagination.total = response.data.pagination.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchFilterFromParams() {
      Object.keys(this.$route.query).forEach((key) => {
        if (key === 'current' || key === 'pageSize') {
          this.pagination[key] = parseInt(this.$route.query[key])
        } else if (key === 'col' || key === 'order') {
          this.sorting[key] = this.$route.query[key]
        } else {
          const queryValue = this.$route.query[key]
          if (Array.isArray(queryValue))
            this.filters[key] = queryValue.slice()
          else
            this.filters[key] = [queryValue]
        }
      })
    },
    saveRouteParams() {
      const queryParams = {}
      Object.keys(this.filters)
        .forEach((key) => {
          if (this.filters[key]) {
            queryParams[key] = this.filters[key]
          }
        })

      queryParams.current = this.pagination?.current ?? 1
      queryParams.pageSize = this.pagination?.pageSize ?? 25

      queryParams.col = this.sorting?.col ?? 'date_created'
      queryParams.order = this.sorting?.order ?? 'desc'

      this.$router.push({
        path: '/admin/seller/orders',
        query: queryParams,
      })
    },
    stringifyItems(itemsArray) {
      if (Array.isArray(itemsArray) && itemsArray.length > 0) {
        return itemsArray.map(it => this.$l(it)).reduce((acc, curr) => acc + `, ${curr}`)
      } else
        return itemsArray.toString()
    },
    mapApiQuery(queryObject, queryType) {
      if (queryType === 'sort')
        return this.mapSortQuery(queryObject)
      else if (queryType === 'filter')
        return this.mapFilterQuery(queryObject)
      else return null
    },
    mapSortQuery(sort) {
      const mappedSort = {}

      Object.keys(sort).forEach((key) => {
        if (apiMapping[sort[key]]) {
          mappedSort[key] = apiMapping[sort[key]].sort
        } else {
          mappedSort[key] = sort[key]
        }
      })

      return mappedSort
    },
    mapFilterQuery(filter) {
      const mappedFilter = {}

      Object.keys(filter).forEach((key) => {
        if (apiMapping[key]) {
          const queryKey = apiMapping[key].filter
          mappedFilter[queryKey] = filter[key]
        } else {
          mappedFilter[key] = filter[key]
        }
      })

      return mappedFilter
    },

    fetchBranches() {
      this.loading = true
      postBranchesService.fetchAllPostBranches()
        .then(response => {
          this.branches = response.data.content.map(branch => {
            return {
              value: branch.id,
              text: branch.title,
            }
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    getIdColor({
      date_updated,
      status,
    }) {
      const date = new Date(date_updated)
      const currentDate = new Date()
      const diff = currentDate.getTime() - date.getTime()
      const diffDays = Math.ceil(diff / (1000 * 3600 * 24))

      if (status.code === 'NEW' || status.code === 'DISPATCHED' || status.code === 'IN_PROGRESS') {
        if (diffDays > 5) {
          return 'btn-danger'
        } else if (diffDays > 3) {
          return 'btn-warning'
        } else {
          return 'btn-light'
        }
      } else {
        return 'btn-light'
      }
    },

  },
}

const orderStatusMap = {
  1: {
    en: 'Draft',
    ru: 'Драфт',
    uz: 'Bekor qilish',
  },
  3: {
    en: 'New',
    ru: 'Новый',
    uz: 'Yangi',
  },
  4: {
    en: 'In Progress',
    ru: 'Обрабатывается',
    uz: 'Qayta ishlanmoqda',
  },
  5: {
    en: 'Dispatched',
    ru: 'Отправлен',
    uz: 'Yuborilgan',
  },
  6: {
    en: 'Delivered',
    ru: 'Доставлен',
    uz: 'Yuborildi',
  },
  7: {
    en: 'Finished',
    ru: 'Финишировал',
    uz: 'Tugatildi',
  },
  8: {
    en: 'Cancelled',
    ru: 'Отменён покупателем',
    uz: 'Xaridor tomonidan bekor qilingan',
  },
  9: {
    en: 'Returned by buyer',
    ru: 'Возвращен покупателем',
    uz: 'Xaridor tomonidan qaytarilgan',
  },
  11: {
    en: 'Declined by seller',
    ru: 'Отменён продавцом',
    uz: 'Rad etildi (sotuvchi tomonidan)',
  },
  12: {
    en: 'Declined to receive',
    ru: 'Отказ в получении',
    uz: 'Rad etildi (sotib oluvchi tomonidan)',
  },
}

const apiMapping = {
  id: {
    sort: 'o.id',
    filter: 'id',
  },
  date_created: {
    sort: 'o.date_created',
  },
  buyer: {
    sort: 'b.last_name',
    filter: 'buyer_name',
  },
  items: {
    filter: 'title',
  },
  amount: {
    sort: 'o.total_price',
  },
  delivery_cost: {
    sort: 'o.delivery_cost',
  },
  status: {
    filter: 'status',
  },
  'company.branch.title': {
    sort: 'pb.title',
  },
}
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
